import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full bg-white rounded-t-[24px] overflow-hidden" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "px-[32px] pb-[24px]" }
const _hoisted_4 = { class: "flex justify-between items-center m-b-[32px]" }
const _hoisted_5 = { class: "m-b-[24px]" }
const _hoisted_6 = {
  key: 0,
  class: "mb-[16px] overflow-hidden"
}
const _hoisted_7 = { class: "text-[24px] text-gray-600 mb-[12px] font-medium" }
const _hoisted_8 = { class: "flex space-x-[8px] px-[4px] py-[8px]" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mr-[8px]" }
const _hoisted_11 = { class: "border-b border-gray-100 cursor-pointer py-[24px] active:bg-gray-50 transition-colors" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "text-[30px] text-gray-900 font-[500px] leading-[1.2]" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "text-[30px] text-gray-900 font-[500px] leading-[1.2]" }
const _hoisted_19 = {
  key: 3,
  class: "text-center py-[120px] text-gray-400"
}
const _hoisted_20 = {
  key: 0,
  class: "bg-white border-t border-gray-100 px-[32px] py-[24px] safe-area-inset-bottom m-t-auto"
}
const _hoisted_21 = { class: "flex space-x-[16px]" }

import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { showToast, vibrateShort } from '@tarojs/taro';
import { xcxUserList } from '@/service/user';

interface UserItem {
  key: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  modelValue: {
    type: [Array, String],
    default: () => [],
  },
  userNames: {
    type: [Array, String],
    default: () => [],
  },
  multiple: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: '请选择人员',
  },
},
  emits: ['update:modelValue', 'update:userNames', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const popupVisible = ref(false);
const userList = ref<UserItem[]>([]);
const searchText = ref('');
const loading = ref(false);

// 选中key - 修复单选逻辑
const selectedKeys = ref<string[]>([]);
const selectedKey = ref<string>('');

// 生成头像颜色
const getAvatarColor = (name: string) => {
  const colors = ['linear-gradient(135deg, #165dff 0%, #165dff 100%)'];
  const index = name.charCodeAt(0) % colors.length;
  return colors[index];
};

// 根据key获取用户名称
const getSelectedUserName = (key: string) => {
  const user = userList.value.find(u => u.key === key);
  return user ? user.value : '';
};

// 搜索输入处理
const onSearchInput = () => {
  // 添加搜索防抖逻辑
  nextTick(() => {
    if (searchText.value.trim()) {
      vibrateShort();
    }
  });
};

// 清空搜索
const clearSearch = () => {
  searchText.value = '';
  vibrateShort();
};
const themeVars = ref({
  radioLabelFontActiveColor: '#165dff',
  radioLabelFontSize: '14px',
  'icon-height': '30px',
  'icon-width': '30px',
});
const themeVarsCheck = ref({
  checkboxLabelColor: '#000',
  primaryColor: '#165dff',
  checkboxMarginRight: '0px',
});
// 打开弹窗
const openPopup = () => {
  popupVisible.value = true;
  vibrateShort();
};

// 多选切换
const toggleMultipleUser = (key: string) => {
  const index = selectedKeys.value.indexOf(key);
  if (index > -1) {
    selectedKeys.value.splice(index, 1);
  } else {
    selectedKeys.value.push(key);
  }
  vibrateShort();
};

// 多选变化处理
const onMultipleChange = (value: string[]) => {
  selectedKeys.value = value;
};

// 单选变化处理
const onSingleChange = (value: string) => {
  selectedKey.value = value;
  const selectedUser = userList.value.find(u => u.key === value);
  emit('update:modelValue', value);
  emit('change', value, selectedUser ? [selectedUser] : []); // 发送key和完整用户数据
  popupVisible.value = false;
  vibrateShort();
  if (selectedUser?.value) {
    showToast({
      title: `已选择 ${selectedUser?.value}`,
      icon: 'none',
      duration: 1500,
    });
  }
};

// 清空所有选择
const clearAll = () => {
  selectedKeys.value = [];
  vibrateShort();
};

// 过滤后的用户
const filteredUsers = computed(() => {
  if (!searchText.value) return userList.value;
  const keyword = searchText.value.toLowerCase();
  return userList.value.filter(
    user =>
      user.value.toLowerCase().includes(keyword) ||
      user.key.toLowerCase().includes(keyword)
  );
});

// 获取选中的用户完整信息
const selectedUsers = computed(() => {
  if (props.multiple) {
    return userList?.value.filter(user =>
      selectedKeys.value.includes(user.key)
    );
  } else {
    const user = userList?.value.find(user => user.key === selectedKey.value);
    return user ? [user] : [];
  }
});

// 计算并同步用户名字（只读）
const selectedUserNames = computed(() => {
  if (props.multiple) {
    return selectedUsers.value.map(user => user.value);
  } else {
    return selectedUsers.value.length > 0 ? selectedUsers.value[0].value : '';
  }
});

// 监听用户名字变化并同步到父组件
watch(
  selectedUserNames,
  newNames => {
    emit('update:userNames', newNames);
  },
  { deep: true }
);

// 多选确认
const confirmSelect = () => {
  const keys = selectedKeys.value;
  const users = selectedUsers.value; // 获取完整用户数据
  const names = users.map(user => user.value); // 获取用户名字数组

  emit('update:modelValue', keys);
  emit('update:userNames', names); // 同步用户名字
  emit('change', keys, users); // 发送keys和完整用户数据

  popupVisible.value = false;
  vibrateShort();
  showToast({
    title: `已选择 ${keys.length} 人`,
    icon: 'none',
    duration: 1500,
  });
};

// 单选选择 - 修复逻辑
const selectSingle = (key: string) => {
  selectedKey.value = key;
  const selectedUser = userList.value.find(u => u.key === key);
  console.log('选中的用户:', selectedUser);

  emit('update:modelValue', key);
  emit('update:userNames', selectedUser ? selectedUser.value : ''); // 同步用户名字
  emit('change', key, selectedUser ? [selectedUser] : []); // 发送key和完整用户数据

  popupVisible.value = false;
  vibrateShort();
  if (!selectedUser) return;
  showToast({
    title: `已选择 ${selectedUser?.value}`,
    icon: 'none',
    duration: 1500,
  });
};

// v-model 同步 - 修复单选逻辑
watch(
  () => props.modelValue,
  val => {
    if (props.multiple) {
      selectedKeys.value = Array.isArray(val) ? (val as string[]) : [];
    } else {
      selectedKey.value = typeof val === 'string' ? val : '';
    }
  },
  { immediate: true }
);

// 获取用户列表
const fetchUsers = async () => {
  loading.value = true;
  try {
    const res = await xcxUserList();
    userList.value = Array.isArray(res.data)
      ? res.data.map((item: any) => ({
          key: String(item.key || item.id || ''),
          value: String(item.value || item.name || ''),
        }))
      : [];
  } catch (e) {
    showToast({ title: '获取人员失败', icon: 'error', duration: 2000 });
  } finally {
    loading.value = false;
  }
};

onMounted(fetchUsers);

return (_ctx: any,_cache: any) => {
  const _component_nut_input = _resolveComponent("nut-input")!
  const _component_taro_scroll_view = _resolveComponent("taro-scroll-view")!
  const _component_nut_checkbox = _resolveComponent("nut-checkbox")!
  const _component_nut_checkbox_group = _resolveComponent("nut-checkbox-group")!
  const _component_nut_config_provider = _resolveComponent("nut-config-provider")!
  const _component_nut_radio = _resolveComponent("nut-radio")!
  const _component_nut_radio_group = _resolveComponent("nut-radio-group")!
  const _component_nut_empty = _resolveComponent("nut-empty")!
  const _component_nut_button = _resolveComponent("nut-button")!
  const _component_nut_popup = _resolveComponent("nut-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onClick: openPopup,
      class: "cursor-pointer"
    }, [
      _renderSlot(_ctx.$slots, "default", {
        selectedUsers: selectedUsers.value,
        selectedCount: selectedUsers.value.length,
        multiple: __props.multiple
      }, () => [
        _createElementVNode("div", {
          class: _normalizeClass(["w-[88px] h-[88px] border-2 border-dashed border-gray-300 rounded-[16px] flex-x-y-center bg-gray-50", { 'border-primary bg-primary/5': popupVisible.value }])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["iconfont LY-tianjia text-primary text-[44px]", { 'rotate-45': popupVisible.value }])
          }, null, 2)
        ], 2)
      ], true)
    ]),
    _createVNode(_component_nut_popup, {
      visible: popupVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((popupVisible).value = $event)),
      position: "bottom",
      style: { height: '95%' },
      "overlay-style": { background: 'rgba(0, 0, 0, 0.5)' },
      "close-on-click-overlay": true,
      round: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-[80px] h-[8px] bg-gray-200 rounded-full mx-auto m-t-[16px] m-b-[24px]" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-[36px] font-[600px] text-gray-900" }, "选择人员", -1)),
                _createElementVNode("div", {
                  class: "w-[56px] h-[56px] rounded-full bg-gray-100 flex-x-y-center cursor-pointer text-[32px] text-gray-500",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (popupVisible.value = false))
                }, " × ")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_nut_input, {
                  modelValue: searchText.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                  type: "search",
                  placeholder: "搜索人员姓名",
                  border: false,
                  "clear-icon": true,
                  onInput: onSearchInput,
                  onClear: clearSearch,
                  class: "search-input"
                }, {
                  left: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "text-[28px] text-gray-400 mr-[12px]" }, "🔍", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createVNode(_Transition, {
                "enter-active-class": "transition-all duration-300 ease-out",
                "leave-active-class": "transition-all duration-300 ease-in",
                "enter-from-class": "opacity-0 transform -translate-y-4 max-h-0",
                "enter-to-class": "opacity-100 transform translate-y-0 max-h-[200px]",
                "leave-from-class": "opacity-100 transform translate-y-0 max-h-[200px]",
                "leave-to-class": "opacity-0 transform -translate-y-4 max-h-0"
              }, {
                default: _withCtx(() => [
                  (__props.multiple && selectedKeys.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, " 已选择 " + _toDisplayString(selectedKeys.value.length) + " 人 ", 1),
                        _createVNode(_component_taro_scroll_view, {
                          "scroll-x": "true",
                          "show-scrollbar": false,
                          class: "whitespace-nowrap"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_TransitionGroup, {
                                name: "tag",
                                tag: "div",
                                class: "flex space-x-[8px]"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedKeys.value, (selectedKey) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: selectedKey,
                                      class: "flex-shrink-0 inline-flex items-center bg-primary/10 text-primary px-[16px] py-[8px] rounded-full text-[25px] font-medium cursor-pointer transition-all duration-200",
                                      onClick: ($event: any) => (toggleMultipleUser(selectedKey))
                                    }, [
                                      _createElementVNode("span", _hoisted_10, _toDisplayString(getSelectedUserName(selectedKey)), 1)
                                    ], 8, _hoisted_9))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "h-[1px] bg-gray-100" }, null, -1))
          ]),
          _createVNode(_component_taro_scroll_view, {
            enablePassive: "",
            enhanced: "",
            refresherTwoLevelEnabled: true,
            refresherTwoLevelTriggered: true,
            "scroll-y": true,
            "scroll-x": false,
            showScrollbar: "",
            scrollWithAnimation: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (__props.multiple)
                  ? (_openBlock(), _createBlock(_component_nut_config_provider, {
                      key: 0,
                      "theme-vars": themeVarsCheck.value,
                      class: "block w-full!"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_nut_checkbox_group, {
                          modelValue: selectedKeys.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                          onChange: onMultipleChange,
                          class: "w-full! block"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (user) => {
                              return (_openBlock(), _createBlock(_component_nut_checkbox, {
                                label: user.key,
                                key: user.key,
                                "text-position": "left",
                                checked: selectedKeys.value.includes(user.key),
                                class: _normalizeClass(["px-[20px] m-b-0! w-full box-border", {
                      'bg-primary/8 border-l-[4px] border-l-primary':
                        selectedKeys.value.includes(user.key),
                    }])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("div", {
                                        class: "w-[80px] h-[80px] rounded-[20px] text-white flex-x-y-center text-[35px] font-[600px] mr-[24px] shadow-sm",
                                        style: _normalizeStyle({ background: getAvatarColor(user.value) })
                                      }, _toDisplayString(user.value.charAt(0)), 5),
                                      _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, _toDisplayString(user.value), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "checked", "class"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["theme-vars"]))
                  : (_openBlock(), _createBlock(_component_nut_config_provider, {
                      key: 1,
                      "theme-vars": themeVars.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_nut_radio_group, {
                          modelValue: selectedKey.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedKey).value = $event)),
                          onChange: onSingleChange,
                          "text-position": "left"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (user) => {
                              return (_openBlock(), _createBlock(_component_nut_radio, {
                                label: user.key,
                                key: user.key,
                                class: _normalizeClass(["px-[20px] m-b-0!", {
                      'bg-primary/8 border-l-[4px] border-l-primary':
                        selectedKey.value === user.key,
                    }])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "border-b border-gray-100 cursor-pointer py-[24px] active:bg-gray-50 transition-colors",
                                    onClick: ($event: any) => (selectSingle(user.key))
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", {
                                        class: "w-[80px] h-[80px] rounded-[20px] text-white flex-x-y-center text-[35px] font-[600px] mr-[24px] shadow-sm",
                                        style: _normalizeStyle({ background: getAvatarColor(user.value) })
                                      }, _toDisplayString(user.value.charAt(0)), 5),
                                      _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, _toDisplayString(user.value), 1)
                                      ])
                                    ])
                                  ], 8, _hoisted_15)
                                ]),
                                _: 2
                              }, 1032, ["label", "class"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["theme-vars"])),
                (!filteredUsers.value.length && !loading.value)
                  ? (_openBlock(), _createBlock(_component_nut_empty, {
                      key: 2,
                      description: "暂无人员数据"
                    }))
                  : _createCommentVNode("", true),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[9] || (_cache[9] = [
                      _createElementVNode("div", { class: "w-[64px] h-[64px] border-[4px] border-gray-200 border-t-primary rounded-full animate-spin mx-auto mb-[24px]" }, null, -1),
                      _createElementVNode("div", { class: "text-[28px] text-gray-500" }, "加载中...", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (__props.multiple)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_nut_button, {
                    type: "default",
                    size: "normal",
                    class: "flex-1",
                    disabled: selectedKeys.value.length === 0,
                    onClick: clearAll
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" 清空 ")
                    ])),
                    _: 1,
                    __: [10]
                  }, 8, ["disabled"]),
                  _createVNode(_component_nut_button, {
                    type: "info",
                    size: "normal",
                    class: "flex-[2]",
                    disabled: selectedKeys.value.length === 0,
                    onClick: confirmSelect
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode(" 确认选择 ")
                    ])),
                    _: 1,
                    __: [11]
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})